<template>
 <router-view></router-view>
</template>

<script>

export default {
  name: 'App',
  components: {
  }
}
</script>

<style>
/* Ocultar completamente el sidebar */
.app-menu {
  display: none !important;
}

/* Ocultar el overlay vertical */
.vertical-overlay {
  display: none !important;
}

/* Ajustar el main-content para que ocupe todo el ancho */
#layout-wrapper .main-content {
  margin-left: 0 !important;
}

/* Ajustar el padding del page-content */
#layout-wrapper .page-content {
  padding: calc(10px + 0.5rem) calc(1.5rem) 60px calc(1.5rem) !important;
}

/* Asegurar que el navbar header use todo el ancho disponible */
.navbar-header {
  width: 100% !important;
}
</style>
